import React from 'react';
import { motion } from 'framer-motion';
import { FiCheck } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const About = () => {
  const benefits = [
    'Your Professional Website',
    'Automations Connected',
    'Lead Capture Ready',
    'Business Growing 24/7'
  ];

  return (
    <section id="about" className="py-24 bg-slate-900 text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="lg:grid lg:grid-cols-2 lg:gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-4xl md:text-6xl font-extrabold mb-8 leading-tight tracking-tight">
              We're More Than Just Your Developers.<br />
              <span className="text-emerald-400">We're Your Growth Partner.</span>
            </h2>
            <p className="text-slate-400 text-xl mb-10 leading-relaxed font-medium max-w-xl">
              We don't just deliver files; we build ecosystems. Our focus is on creating long-term business value through technology that works for you while you sleep.
            </p>
          </motion.div>

          <div className="mt-12 lg:mt-0 grid grid-cols-1 sm:grid-cols-2 gap-6">
            {benefits.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1, duration: 0.5 }}
                className="bg-white/5 backdrop-blur-sm p-8 rounded-[2.5rem] border border-white/10 flex flex-col items-start hover:bg-white/10 transition-all group cursor-default"
              >
                <div className="bg-emerald-500 text-slate-900 p-2.5 rounded-xl mb-6 shadow-[0_0_20px_rgba(16,185,129,0.3)] group-hover:scale-110 transition-transform">
                  <SafeIcon icon={FiCheck} className="text-xl font-bold" />
                </div>
                <span className="text-white text-lg font-bold tracking-tight">{item}</span>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
